import { supabase } from '@/shared/lib/supabase/client';
import { AppError } from '@/shared/lib/repository/errors';
import { mapArticle, mapArticleSummary } from '@/entities/article';
import type { Article, ArticleSummary } from '@/entities/article';

const AUTHOR_EMBED =
  'author:profiles!articles_author_id_fkey(id, name, initials, avatar_color, avatar_url)';
const SUMMARY_SELECT = `id, slug, title, excerpt, category, cover_url, read_time, published_at, ${AUTHOR_EMBED}`;
const DETAIL_SELECT = `*, ${AUTHOR_EMBED}`;

/** Read access to articles. Published-only reads are enforced by RLS as well. */
export const articleRepository = {
  async listPublished(): Promise<ArticleSummary[]> {
    const { data, error } = await supabase
      .from('articles')
      .select(SUMMARY_SELECT)
      .eq('status', 'published')
      .order('published_at', { ascending: false });
    if (error) throw new AppError(error.message, error.code, error);
    return (data ?? []).map(mapArticleSummary);
  },

  async getPublishedBySlug(slug: string): Promise<Article | null> {
    const { data, error } = await supabase
      .from('articles')
      .select(DETAIL_SELECT)
      .eq('slug', slug)
      .eq('status', 'published')
      .maybeSingle();
    if (error) throw new AppError(error.message, error.code, error);
    return data ? mapArticle(data) : null;
  },
};
